import Mail from "../../component/mail/Mail";
function Contact() {
  return <Mail />;
}

export default Contact;
